import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8beb086"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewLink = _resolveComponent("PreviewLink")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_UserDetailModal = _resolveComponent("UserDetailModal")!
  const _component_SiteUserModal = _resolveComponent("SiteUserModal")!
  const _component_AddEditModal = _resolveComponent("AddEditModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      tableFilter: _ctx.tableFilter,
      addButtonText: `${_ctx.t('pages.site.assignUser')}`,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      viewName: "userSites",
      pageName: "siteUser",
      onQueryUpdate: _ctx.syncQuery,
      onFormSubmit: _ctx.submit,
      customForm: true,
      onCustomForm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.customForm())),
      permissions: _ctx.permissionModel,
      ref: "Datatable"
    }, {
      "cell-name": _withCtx(({ row: site }) => [
        _createTextVNode(_toDisplayString(site.name) + " ", 1),
        _createVNode(_component_PreviewLink, {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          routerName: {
          name: 'detail.user',
          params: { id: site.userAccountId },
        }
        }, null, 8, ["routerName"])
      ]),
      "cell-roleName": _withCtx(({ row: site }) => [
        (site.roleName)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["badge fw-bold m-1", _ctx.getClass(site.roleName)])
            }, _toDisplayString(site.roleName), 3))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-sm btn-primary",
              onClick: ($event: any) => (_ctx.openRoleModal(site))
            }, _toDisplayString(_ctx.t("pages.user.assignRole")), 9, _hoisted_1))
      ]),
      "cell-createdDate": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.format.convertUTCToLocalDate(site.createdDate, "MM-DD-YYYY hh:mm A")), 1)
      ]),
      "cell-actions": _withCtx(({ row: site }) => [
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.openDeleteDialog(site)), ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_5, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "tableFilter", "addButtonText", "bulkDelete", "tableForm", "onQueryUpdate", "onFormSubmit", "permissions"]),
    _createVNode(_component_VZDeleteModal, {
      viewName: "userSites",
      showDialog: _ctx.showDeleteDialog,
      selectedForAction: [_ctx.selectedForAction.webId],
      deleteText: `${_ctx.t('validation.sureToDelete')} ${_ctx.selectedForAction.name}?`,
      pageName: "user",
      onClose: _ctx.refreshList,
      onOnDelete: _ctx.onDelete
    }, null, 8, ["showDialog", "selectedForAction", "deleteText", "onClose", "onOnDelete"]),
    _createVNode(_component_UserDetailModal, {
      viewName: "user_detail_modal",
      data: _ctx.selectedUser,
      loading: _ctx.loadingUserDetailModal,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "loading", "showDialog"]),
    _createVNode(_component_SiteUserModal, {
      ref: "addUserModel",
      data: _ctx.siteUserModalData,
      tableData: _ctx.allTableData,
      onSubmit: _ctx.refreshList,
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event))
    }, null, 8, ["data", "tableData", "onSubmit", "modelValue"]),
    _createVNode(_component_AddEditModal, {
      viewName: "user_site_modal",
      modelValue: _ctx.showAddSiteRole,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showAddSiteRole) = $event)),
      data: _ctx.computedUserSiteModalData,
      "on@onClose": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddSiteRole = false)),
      onOnSubmit: _ctx.submitSiteRole,
      onOnCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showAddSiteRole = false))
    }, null, 8, ["modelValue", "data", "onOnSubmit"])
  ], 64))
}